import React from "react";
import { createPortal } from "react-dom";

const FloatingCardTemplate = ({ children }) => {
    return createPortal(<div className="c-floating-card">{children}</div>, document.body);
};

export default FloatingCardTemplate;
